<template>
	<v-card class="elevation-0 partners-page partners-page-container pt-7 mb-10">
		<div class="d-flex">
			<v-skeleton-loader
				v-if="isLoading"
				v-bind="attrs"
				width="600"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
				<div class="mb-4 d-flex text-decoration-none">
					<v-icon small class="mr-1"> mdi-arrow-left-circle</v-icon>
					<div class="event-card__link" @click="$router.back()">Back</div>
				</div>

				<div class="agenda-page__title">{{ this.name }}</div>

				<div v-for="(speaker, index) in speakers" :key="index">
					<router-link
						:to="{
							name: 'speaker-by-id',
							params: {
								id: +speaker.speaker_id
							}
						}"
						class='d-flex flex-column text-decoration-none'
					>
						<SpeakerCard :speaker="speaker" />
					</router-link>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SpeakerCard from '@/components/Event/SpeakerCard'

export default {
	name: 'SpeakersPage',

	components: {
		SpeakerCard
	},

	props: {
		name: {
			type: String,
			default: 'Speakers',
		},
	},

	methods: {
		...mapActions('event', ['fetchPartners', 'getSession']),

		onPageChange(page) {
			const params = {
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getPartners(queryString)
		},

		formatFilters(filters) {
			const { page } = filters

			return `&group_id=${this.$route.params.id}&page=${page}`
		},

		async getPartners(additionalQueryParams = '') {
			await this.fetchPartners(additionalQueryParams)
		},
	},

	created() {
		if (this.$route.params.sessionId) {
			this.getSession(this.$route.params.sessionId)
		}
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountPartners', 'session']),

		speakers() {
			const {speakers = []} = this.session;

			return speakers;
		}
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
		}
	},
}
</script>

<style lang="scss">
.partners-page {
	background: #f1f1f1 !important;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		margin-bottom: 10px;
	}
}

@media screen and (min-width: 1200px) {
	.partners-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.partners-page-container {
		max-width: 600px;
	}
}
</style>
